export const modelToModelIdsNumber = models => models?.map(mId => Number(mId?.id))
